/**
 * @name showCampaignsStickers
 * @description
 * Show logo of campaign associated to collection
 */
export default function showCampaignsStickers() {

    let additionalProductFieldActive = true;
    const campaignSticker = document.querySelector('#campaign-stickers');

    // Check Active Image to Campaign
    if (window.campaigns_stickers.length > 0 && !campaignSticker) {

        // Get all products
        const els = document.getElementsByClassName("snize-product");
        Array.prototype.forEach.call(els, function (el) {
            const elPrice = el.querySelector(".snize-price.money");
            const oldPrice = elPrice?.dataset.oldPrice;

            if(!additionalProductFieldActive) return;

            const productTags = []
            Array.prototype.forEach.call(el.classList, function (tag) {
                if (tag.includes("snize-product-tag")) {
                    const cleanTag = tag.replace("snize-product-tag-", "").replaceAll(/(-)|(_)/g, "").toLowerCase();
                    productTags.push(cleanTag);
                }
            })

            // Remove innecesary tag and get collections
            if(el.getElementsByClassName("snize-attribute-title").length !== 0) el.getElementsByClassName("snize-attribute-title")[0].remove();

            // Check if Display additional product field option is active
            if(el.getElementsByClassName("snize-attribute").length === 0){
                console.error('Smart Search & Instant Search - Display additional product field collections option is not active, please check the app config.');
                additionalProductFieldActive = false;
            }else{
                const collections = el.getElementsByClassName("snize-attribute")[0].innerText.split(', ').map((e) => string_to_slug(decodeURI(encodeURI(e))));
                const stickersCampaign = window.campaigns_stickers.filter(ci => collections.includes(ci.campaign) || productTags.includes(ci.tag.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '').toLowerCase()));

                var stickers = [];
                var hasBrandSticker = false;
                var hasRegionalSticker = false;
                var hasDeliverySticker = false;

                for (const sticker of stickersCampaign) {
                    switch (sticker.stickerType) {
                        case 'brand':
                          if (!hasBrandSticker) {
                            sticker.order = 1;
                            stickers.push(sticker);
                            hasBrandSticker = true;
                          }
                          break;
                        case 'regional':
                          if (!hasRegionalSticker) {
                            sticker.order = 2;
                            stickers.push(sticker);
                            hasRegionalSticker = true;
                          }
                          break;
                        case 'delivery':
                          if (!hasDeliverySticker) {
                            sticker.order = 3;
                            stickers.push(sticker);
                            hasDeliverySticker = true;
                          }
                          break;
                        default:
                          break;
                    }
                }

                if(stickers.length){

                    //Order stickers by type
                    stickers.sort((a, b) => (a.order - b.order));

                    // Create the main container
                    const stickersContainer = document.createElement("div");
                    stickersContainer.id = "campaign-stickers";
                    el.getElementsByClassName("snize-view-link")[0].appendChild(stickersContainer);

                    // Check and Apply Image
                    for (const ci of stickers) {

                        // Create the main container
                        const mainContainer = document.createElement("div");
                        mainContainer.className = "container-campaign-sticker";
                        stickersContainer.appendChild(mainContainer);

                        // Create containet with image and applen in main container
                        const stickerContainer = document.createElement("div");
                        stickerContainer.className = "campaign-sticker";
                        const linkElement = document.createElement("a");
                        linkElement.setAttribute("src", ci.link);
                        linkElement.innerText = ci.title;
                        stickerContainer.appendChild(linkElement);
                        mainContainer.appendChild(stickerContainer);

                        const bgColor = ci.bgColor.replace("#", "");
                        const textColor = ci.textColor.replace("#", "");

                        if (bgColor != undefined && bgColor != "") {
                            mainContainer.classList.add(`bg-color_${bgColor}`);
                        }

                        if (textColor != undefined && textColor != "") {
                            linkElement.classList.add(`text-color_${textColor}`);
                        }

                    }
                }

            }
        });
    }
};